import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService) {
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (!!localStorage.getItem('currentUser') == true) {
            return true;
        } 
            this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        
    }
    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    //     let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    //     return this._userService.verify().map(
    //         data => {
    //             if (data !== null) {
    //                 // logged in so return true
    //                 return true;
    //             }
    //             // error when verify so redirect to login page with the return url
    //             this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //             return false;
    //         },
    //         error => {
    //             // error when verify so redirect to login page with the return url
    //             this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //             return false;
    //         });
    // }
}